export default () => {

  $('.menu-event').click((e) => {
    e.preventDefault();
    $('.menu-button-static').toggleClass('close');
    $('.menu-outer').toggleClass('animation-show prepare-show show');
  })

  $('.menu-close').click(() => {
    $('.menu-button-static').removeClass('close');
    $('.menu-outer').removeClass('animation-show prepare-show show');
  })
}


// WEBPACK FOOTER //
// app/scripts/components/menu.js